import React, {useEffect, useState } from 'react';
import '../assets/css/gallery.css';
import Zoomimage from '../Component/Zoomimage';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import img001 from '../../src/assets/images/c1.jpg'

const Gallery = ({ mainimage }) => {
  const galleryImages = [
    { id: 2, src: img001, alt: 'Image 2' },
    { id: 3, src: img001, alt: 'Image 3' },
    { id: 4, src: img001, alt: 'Image 4' },
    { id: 5, src: img001, alt: 'Image 5' },
    { id: 6, src: img001, alt: 'Image 6' },
    { id: 7, src: img001, alt: 'Image 7' },
    { id: 8, src: img001, alt: 'Image 8' },
    { id: 9, src: img001, alt: 'Image 9' },
    
    // Add more as needed
  ];
  const allImages = [
    { id: 1, src: mainimage, alt: 'Main Image' },
    ...galleryImages.filter(img => img.src !== mainimage),
  ];
  const [mainImage, setMainImage] = useState(mainimage);
  const [activeThumbnail, setActiveThumbnail] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const thumbnailsPerPage = 7; 
  const handleThumbnailClick = (src, id) => {
    setMainImage(src);
    setActiveThumbnail(id);
  };
  const handlePrev = () => {
    setStartIndex(prev => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    const maxIndex = Math.max(allImages.length - thumbnailsPerPage, 0);
    setStartIndex(prev => Math.min(prev + 1, maxIndex));
  };
  const visibleThumbnails = allImages.slice(startIndex, startIndex + thumbnailsPerPage);
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate data fetching delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 seconds delay

    return () => clearTimeout(timer);
  }, []);

  return (

    <> 
    <div className="gallery-container">
      <div className="row">
       
        <div className="col-md-10 col-9">
        {isLoading ? (
            <Skeleton count={1} height={600} width={430} className="mb-2" />
          ) : (
          <div className="main-image">
            <img src={mainImage} alt="Main" className="main-image-img"   
             onClick={() => handleImageClick(mainImage)} 
             />
             <span className='zoomicon' onClick={() => handleImageClick(mainImage)} >  <i className="bi bi-zoom-in"></i> </span>
          </div>
          )}
        </div>

        <div className="col-md-2 col-3">
          {isLoading ? (
            <Skeleton count={5} height={100} className="mb-2" />
            
          ) : (
          <div className="thumbnail-wrapper">
            <button onClick={handlePrev} className="nav-btn" disabled={startIndex === 0}> <i className="bi bi-chevron-up"></i> </button>
            <div className="thumbnail-container">
              {visibleThumbnails.map(img => (
                <img
                  key={img.id}
                  src={img.src}
                  alt={img.alt}
                  onClick={() => handleThumbnailClick(img.src, img.id)}
                  className={`thumbnail ${activeThumbnail === img.id ? 'active' : ''}`}
                />
              ))}
            </div>
            <button
              onClick={handleNext}
              className="nav-btn"
              disabled={startIndex + thumbnailsPerPage >= allImages.length}
              >
               <i className="bi bi-chevron-down"></i>
            </button>
          </div>
           )}
        </div>
      </div>
    </div>
      <Zoomimage 
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalImage={modalImage}
      />
    </>
  );
};
export default Gallery;
